/**
 * ? @description : APR Information Component
 */

// Dependencies
import React from "react";
import { Form } from "react-bootstrap";
import {
  Box,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@mui/material";

export default function APRInfo({
  formData,
  setFormData,
  validationRes,
  setValidationRes,
}) {
  // const [residingApr, setresidingApr] = useState(null);

  // const buttonValue = (event) => {
  //   // e.preventDefault();
  //   if (event.target.value === "true") {
  //     setresidingApr(true);
  //   } else setresidingApr(false);
  // };
  
  return (
    <div>
      <Form>
        {/* <Box>
          <FormControl>
            <FormLabel id="is-apr-residing">
              Are you residing in Adarsh Palm Retreat ?&nbsp;
              <span style={{ color: "red" }}>*</span>
            </FormLabel>
            <RadioGroup
              aria-labelledby="is-apr-residing"
              name="controlled-radio-buttons-group"
              value={formData.is_apr_residing}
              onChange={(event) => {
                setFormData({
                  ...formData,
                  is_apr_residing: event.target.value === "true" ? true : false,
                  apr_homeaddress : formData.is_apr_residing ? "others" : ""
                });
                setValidationRes({
                  ...validationRes,
                  isInvalidAprResiding: false,
                });
                // setresidingApr(event.target.value === "true" || false)
                // buttonValue(event);
              }}
            >
              <FormControlLabel value={"true"} control={<Radio />} label="Yes" />
              <FormControlLabel value={"false"} control={<Radio />} label="No" />
            </RadioGroup>
          </FormControl>
        </Box> */}

        {/* { formData.is_apr_residing && 
        <Box>
          <FormControl>
            <FormLabel id="apr-home-address">
              Adarsh Palm Retreat Home Address&nbsp;
              <span style={{ color: "red" }}>*</span>
            </FormLabel>
            <RadioGroup
              aria-labelledby="apr-home-address"
              name="controlled-radio-buttons-group"
              value={formData.apr_homeaddress}
              onChange={(event) => {
                setFormData({
                  ...formData,
                  apr_homeaddress: event.target.value,
                });
                setValidationRes({
                  ...validationRes,
                  isInvalidAprHomeAddress: false,
                });
              }}
            >
              <FormControlLabel
                value="APR Villas"
                control={<Radio />}
                label="APR Villas"
              />
              <FormControlLabel
                value="APR Towers"
                control={<Radio />}
                label="APR Towers"
              />
            </RadioGroup>
          </FormControl>
        </Box>} */}

        {/* <Box sx={{ display: residingApr ? "none" : "block" }}>
          <FormControl>
            <FormLabel id="apr-home-address">
              Adarsh Palm Retreat Home Address&nbsp;
              <span style={{ color: "red" }}>*</span>
            </FormLabel>

            <RadioGroup
              aria-labelledby="apr-home-address"
              name="controlled-radio-buttons-group"
              value={formData.apr_homeaddress}
              onChange={(event) => {
                setFormData({
                  ...formData,
                  apr_homeaddress: event.target.value,
                });
                setValidationRes({
                  ...validationRes,
                  isInvalidAprHomeAddress: false,
                });
              }}
            >
              <FormControlLabel
                value="Others"
                control={<Radio />}
                label="Others"
              />
            </RadioGroup>
          </FormControl>
        </Box> */}

        {/* {formData.is_apr_residing === false && <div>
          <Form.Group className="mb-3 form-info">
            <Form.Label>
              Please enter Adarsh Palm Retreat reference name{" "}
              <span style={{ color: "red" }}>*</span>
            </Form.Label>

            <Form.Control
              type="name"
              name="apr_reference_name"
              placeholder="Enter APR name"
              // style={{ width: "250px" }}
              value={formData.apr_reference_name}
              onChange={(event) => {
                setFormData({
                  ...formData,
                  apr_reference_name: event.target.value,
                });
                setValidationRes({...validationRes, isInvalidAprReferenceName: false, isInvalidAprReferenceNameFormate:false});
              }}
              isInvalid = {validationRes.isInvalidAprReferenceName || validationRes.isInvalidAprReferenceNameFormate}
            />

            <Form.Control.Feedback type="invalid">
            {validationRes.isInvalidAprReferenceName ?' Reference name is mandatory and should be less than 20 characters.' :'' }
             {validationRes.isInvalidAprReferenceNameFormate ? 'Reference name name should consist only of alphabetical values': ''}
            </Form.Control.Feedback>
          </Form.Group>
        </div>} */}

        {/* {formData.is_apr_residing === false && <div>
          <Form.Group className="mb-3 form-info">
            <Form.Label>
              Please enter Adarsh Palm Retreat reference mobile number{" "}
              <span style={{ color: "red" }}>*</span>
            </Form.Label>

            <Form.Control
              type="tel"
              name="apr_reference_contact"
              placeholder="Enter mobile number"
              // style={{ width: "250px" }}
              value={formData.apr_reference_contact}
              onChange={(event) => {
                setFormData({
                  ...formData,
                  apr_reference_contact: event.target.value,
                });
                setValidationRes({
                  ...validationRes,
                  isInvalidAprReferenceNumber: false,
                  isInvalidAprReferenceNumberFormate:false,
                });
              }}
              isInvalid={validationRes.isInvalidAprReferenceNumber || validationRes.isInvalidAprReferenceNumberFormate}
            />

            <Form.Control.Feedback type="invalid">
            {validationRes.isInvalidAprReferenceNumber ?'Reference mobile number is mandatory and must contains 10 digits.':''}
              {validationRes.isInvalidAprReferenceNumberFormate ?'Reference mobile number is not valid': ''}
            </Form.Control.Feedback>
          </Form.Group>
        </div>} */}
           <Box>
  <Form.Group className="mb-3 form">
    <Form.Label>
      City of Residence&nbsp;
      <span style={{ color: "red" }}>*</span>
    </Form.Label>

    <Form.Control
      type="text"
      name="city"
      value={formData.city}
      onChange={(event) => {
        setFormData({
          ...formData,
          city: event.target.value,
        });

        setValidationRes({
          ...validationRes,
          isInvalidCity: false,
        });
      }}
      isInvalid={validationRes.isInvalidCity}
    />

    <Form.Control.Feedback type="invalid">
      City of residence is mandatory.
    </Form.Control.Feedback>
  </Form.Group>
</Box>
      </Form>
    </div>
  );
}
